import { extractImageFrames, clampTo } from '../../tools';
import type { KieModelConfig } from '../types';

export const googleConfigs: Record<string, KieModelConfig> = {
    'gemini-omni-flash': {
        // https://kie.ai/gemini-omni
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, videoUri, duration, aspectRatio, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'gemini-omni-video',
                    input: {
                        prompt: prompt.slice(0, 20000),
                        aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16'] as const, '16:9'),
                        duration: String(clampTo(duration || 8, [4, 6, 8, 10] as const, 8)),
                        resolution: clampTo(quality || '720p', ['720p', '1080p', '4k'] as const, '720p'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 首帧 URL
                        image_urls: [firstImage!],
                        // system
                        audio_ids: undefined,
                        character_ids: undefined,
                    },
                };
            // 参考模式
            } else if (frameMode === 'ref') {
                return {
                    model: 'gemini-omni-video',
                    input: {
                        prompt: prompt.slice(0, 20000),
                        aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16'] as const, '16:9'),
                        duration: String(clampTo(duration || 8, [4, 6, 8, 10] as const, 8)),
                        resolution: clampTo(quality || '720p', ['720p', '1080p', '4k'] as const, '720p'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 参考 URL
                        image_urls: imagePrompt!.slice(0, 7),
                        // system
                        audio_ids: undefined,
                        character_ids: undefined,
                    },
                };
            // 视频参考模式
            } else if (frameMode === 'v2v') {
                return {
                    model: 'gemini-omni-video',
                    input: {
                        prompt: prompt.slice(0, 20000),
                        aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16'] as const, '16:9'),
                        duration: String(clampTo(duration || 8, [4, 6, 8, 10] as const, 8)),
                        resolution: clampTo(quality || '720p', ['720p', '1080p', '4k'] as const, '720p'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 参考 URL
                        ...(imagePrompt?.length ? { image_urls: imagePrompt.slice(0, 5) } : {}),
                        // 视频 URL
                        video_list: [
                            {
                                url: videoUri, start: 0, ends: Math.min(10, Math.max(1, Math.floor(providerOptions?._media?.videoDurationSeconds ?? 10)))
                            }
                        ],
                        // system
                        audio_ids: undefined,
                        character_ids: undefined,
                    },
                };
            // 文生视频模式
            } else {
                return {
                    model: 'gemini-omni-video',
                    input: {
                        prompt: prompt.slice(0, 20000),
                        aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16'] as const, '16:9'),
                        duration: String(clampTo(duration || 8, [4, 6, 8, 10] as const, 8)),
                        resolution: clampTo(quality || '720p', ['720p', '1080p', '4k'] as const, '720p'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // system
                        audio_ids: undefined,
                        character_ids: undefined,
                    },
                };
            }
        },
    },
};